<template>
  <HrPageLayout
    title="My Position Info"
    subtitle="Update your current position title and supervisor details."
    icon="👔"
    :breadcrumb-items="[
      { label: 'Dashboard', route: '/dashboard' },
      { label: 'Self Service' },
      { label: 'Position Info' }
    ]"
  >
    <div class="hr-chart-card hr-mb-4" style="max-width: 600px; margin: 0 auto;">
      <div class="hr-chart-head">
        <h6 class="hr-chart-title">Current Position & Supervisor</h6>
      </div>
      <div class="hr-chart-body">
        <div v-if="loading" class="hr-loading-wrap hr-py-4">
          <div class="hr-spinner"></div>
          <p class="hr-text-muted">Loading...</p>
        </div>
        <form v-else @submit.prevent="saveInfo">
          <div class="hr-mb-3">
            <label class="hr-form-label">Position Title <span class="hr-text-danger">*</span></label>
            <input 
              v-model="form.positionTitle" 
              type="text" 
              class="hr-input" 
              placeholder="e.g. Senior Software Engineer"
              required
            >
          </div>
          <div class="hr-mb-4">
            <label class="hr-form-label">Supervisor / Reporting To <span class="hr-text-danger">*</span></label>
            <input 
              v-model="form.reportingTo" 
              type="text" 
              class="hr-input" 
              placeholder="e.g. Jane Doe"
              required
            >
          </div>
          <div class="hr-flex hr-justify-end">
            <button type="submit" class="hr-btn hr-btn-primary" :disabled="saving">
              <span v-if="saving" class="hr-spinner small hr-mr-2"></span>
              <i v-else class="bx bx-save hr-mr-2"></i> {{ saving ? 'Saving...' : 'Save Changes' }}
            </button>
          </div>
          <div v-if="message" :class="['hr-alert hr-mt-3', isError ? 'hr-alert-danger' : 'hr-alert-success']">
            {{ message }}
          </div>
        </form>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { execute, authUrl } from "@/api";

export default {
  name: "EmployeePositionInfo",
  components: { HrPageLayout },
  data() {
    return {
      loading: false,
      saving: false,
      message: "",
      isError: false,
      form: {
        positionTitle: "",
        reportingTo: ""
      }
    };
  },
  mounted() {
    this.loadInfo();
  },
  methods: {
    async loadInfo() {
      this.loading = true;
      this.message = "";
      try {
        const data = new FormData();
        data.append("function", "getEmployeePositionInfo");
        const res = await execute(data, authUrl);
        if (res?.data?.success) {
          const info = res.data.data;
          this.form.positionTitle = info?.positionTitle || "";
          this.form.reportingTo = info?.reportingTo || "";
        }
      } catch (err) {
        console.error("Failed to load position info", err);
      } finally {
        this.loading = false;
      }
    },
    async saveInfo() {
      if (!this.form.positionTitle || !this.form.reportingTo) return;
      this.saving = true;
      this.message = "";
      this.isError = false;
      try {
        const data = new FormData();
        data.append("function", "saveEmployeePositionInfo");
        data.append("positionTitle", this.form.positionTitle);
        data.append("reportingTo", this.form.reportingTo);
        const res = await execute(data, authUrl);
        
        if (res?.data?.success) {
          this.message = res.data.message || "Saved successfully.";
          this.isError = false;
        } else {
          this.message = res?.data?.message || "Failed to save.";
          this.isError = true;
        }
      } catch (err) {
        console.error("Save error", err);
        this.message = "Network error. Please try again.";
        this.isError = true;
      } finally {
        this.saving = false;
        setTimeout(() => { this.message = ""; }, 5000);
      }
    }
  }
};
</script>

<style scoped>
</style>
